import bootstrap from "bootstrap/dist/js/bootstrap.bundle";

/*export const closeModal = (modalID, modals) => {
    if (modalID === 'confirmResetOrderModal') {
        bootstrap.Modal.getInstance(modals.confirmResetOrderModal.value)?.hide();
    }
    if (modalID === 'confirmOutOfRangeModal') {
        bootstrap.Modal.getInstance(modals.confirmOutOfRangeModal.value)?.hide();
    }
    if (modalID === 'confirmAssembledModal') {
        bootstrap.Modal.getInstance(modals.confirmAssembledModal.value)?.hide();
    }
};

export const openModal = (modalID, modals, confirm_out_of_range_seen) => {
    if (modalID === 'confirmResetOrderModal') {
        bootstrap.Modal.getInstance(modals.confirmResetOrderModal.value)?.show();
    }
    if (modalID === 'confirmOutOfRangeModal') {
        confirm_out_of_range_seen.value = true;
        bootstrap.Modal.getInstance(modals.confirmOutOfRangeModal.value)?.show();
    }
    if (modalID === 'confirmAssembledModal') {
        bootstrap.Modal.getInstance(modals.confirmAssembledModal.value)?.show();
    }
};*/

export const closeModal = (modalRef = showAlertMessagesModal) => {
  bootstrap.Modal.getInstance(modalRef.value)?.hide();
}
export const openModal = (modalRef) => {
    if (modalRef === 'confirmOutOfRangeModal') {
        confirm_out_of_range_seen.value = true;
    }
    if (modalRef && modalRef.value) {
        bootstrap.Modal.getInstance(modalRef.value)?.show();
    } else {
        console.warn('Modal instance not ready:', modalRef);
    }
}